import React from 'react';
import { useParams } from 'react-router-dom';

import { useUserPackages } from 'lib/hooks/queries/packages/useUserPackages';

import AgTablePage from 'components/shared/AgTablePage/AgTablePage';

import { sumBy } from '../../../../../../lib/helpers/utility';

import PreviewInvoicePackageModal from './components/PreviewInvoicePackageModal';
import { getColDefs } from './lib/columns';
import { DEFAULT_FILTERS } from './lib/defaultFilters';

const PurchasedPackages = () => {
  const { id: patientId } = useParams();

  const cols = getColDefs();

  const formatPackages = (data) => {
    const formattedData = {
      ...data,
      invoicePackages: data.invoicePackages
        .flatMap((invoicePack) => {
          let amountPaid = invoicePack?.amount_paid + (invoicePack?.discount?.amount_cents || 0);

          amountPaid -=
            sumBy(invoicePack?.procedures, 'total_cost_cents') +
            invoicePack?.tax -
            (invoicePack?.write_off || 0);

          const { packages = [], ...currInvoice } = invoicePack;

          return packages.map((pack) => {
            const isCancelled = pack?.status === 'cancelled';

            const packCharge = (isCancelled ? 0 : pack?.total_amount_cents) || 0;

            const minAmount = Math.min(packCharge, amountPaid);

            amountPaid -= minAmount;

            return {
              ...pack,
              currInvoice,
              created_at: invoicePack.created_at,
              balance: packCharge - minAmount
            };
          });
        })
        .filter(Boolean)
    };

    return formattedData;
  };

  return (
    <AgTablePage
      noTitle
      noNewButton
      name="invoicePackages"
      title="Invoice Packages"
      defaultFilters={DEFAULT_FILTERS}
      useData={useUserPackages}
      rowStyle={{ cursor: 'pointer' }}
      ModalComponent={({ item, handleClose }) =>
        item ? (
          <PreviewInvoicePackageModal
            singlePackageDetails={item}
            setSinglePackageDetails={handleClose}
          />
        ) : null
      }
      queryParams={{ patientId }}
      queryOptions={{ select: formatPackages }}
      defaultColumns={cols}
    />
  );
};

export default PurchasedPackages;
